import { Flex, Image } from "@chakra-ui/react";
import CustomText from "../../components/text/customText";
import yolo from "../../assets/icons/table/image 1.png";
import { IconThumbUp, IconTilde } from "@tabler/icons-react";

import twitter from "../../assets/icons/tag-icons/twitter.svg";
import eth from "../../assets/icons/tag-icons/eth.svg";
import binance from "../../assets/icons/tag-icons/binance.svg";
import mail from "../../assets/icons/tag-icons/mail.svg";
import bit from "../../assets/icons/tag-icons/bit.svg";
import notes from "../../assets/icons/tag-icons/notes.svg";

export const columns = [
  {
    name: "TYPE",
    value: "TYPE",
    key: "type",
    isChevron: true,
  },
  {
    name: "PROJECT",
    value: "PROJECT",
    key: "project",
    isChevron: false,
  },
  {
    name: "REWARDS",
    value: "REWARDS",
    key: "rewards",
    isChevron: true,
  },
  {
    name: "START DATE",
    value: "START_DATE",
    key: "startDate",
    isChevron: true,
  },
  {
    name: "END DATE",
    value: "END_DATE",
    key: "endDate",
    isChevron: true,
  },
  {
    name: "REQUIREMENT",
    value: "REQUIREMENT",
    key: "requirement",
    isChevron: false,
  },
  {
    name: "RATE",
    value: "RATE",
    key: "rate",
    isChevron: true,
  },
  {
    name: "STATUS",
    value: "STATUS",
    key: "status",
    isChevron: true,
  },
  {
    name: "Like",
    value: "Like",
    key: "like",
    isChevron: false,
  },
];

export const rows = [
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={bit} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"} justifyContent={"flex-start"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
          whiteSpace={"nowrap"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#DD1B78"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          text={"ONGOING"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    Like: true,
  },
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={eth} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#0ABBB0"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          align={"center"}
          text={"CLOSE SOON"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
  },
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={binance} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#DD1B78"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          text={"ONGOING"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    Like: true,
  },
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={bit} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#0ABBB0"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          text={"CLOSE SOON"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    Like: true,
  },
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={binance} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#FBFF42"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          text={"OPEN SOON"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
  },
  {
    TYPE: (
      <Flex
        borderRadius={"100px"}
        bg={"#3E414A"}
        height={"25px"}
        width={"25px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Image src={eth} boxSize={"14px"} />
      </Flex>
    ),
    PROJECT: (
      <Flex gap={"12px"} alignItems={"center"}>
        <Image src={yolo} alt="ico" sizes="40px" borderRadius={"160px"} />
        <CustomText
          text={"YOLO Games"}
          color={"#FFF"}
          size={"20px"}
          weight={"500"}
          fontFamily={"Montserrat"}
          h={"20px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),

    REWARDS: (
      <CustomText
        text={"20K NFT"}
        color={"#FFF"}
        size={"16px"}
        weight={400}
        fontFamily={"Montserrat"}
        h={"16px"}
        letterSpacing={"-0.5px"}
      />
    ),
    DATE: (
      <Flex gap={"12px"} alignItems={"center"}>
        <CustomText
          text={"24.04.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
        <IconTilde size={"10px"} color="#FFF" />
        <CustomText
          text={"24.05.00"}
          color={"#FFF"}
          size={"16px"}
          weight={400}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    REQUIREMENT: (
      <Flex alignItems={"center"} gap={"12px"}>
        <Image alt="icon" src={twitter} boxSize={"16px"} />
        <Image alt="icon" src={mail} boxSize={"16px"} />
        <Image alt="icon" src={notes} boxSize={"16px"} />
      </Flex>
    ),
    RATE: (
      <Flex gap={"8px"} alignItems={"center"}>
        <IconThumbUp size={"16px"} color="#FFF" />

        <CustomText
          text={"999"}
          color={"#FFF"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    STATUS: (
      <Flex
        bg={"#FFF"}
        borderRadius={"100px"}
        maxWidth={"118px"}
        width={"100%"}
        p={"2px 4px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CustomText
          text={"CLOSED"}
          color={"#000"}
          size={"16px"}
          weight={700}
          fontFamily={"Montserrat"}
          h={"16px"}
          letterSpacing={"-0.5px"}
        />
      </Flex>
    ),
    Like: true,
  },
];
export const emptyRows: any = [];
